// @flow

import React from "react";

import { ServiceManager } from "../service/service-manager";

import { Validation } from "../model/validation";

import { ResetPassword } from "../components/reset-password/index";
import { queryParam } from "../util/query";

type Props = {
    serviceManager: ServiceManager
};

type States = {
    token: string,
    password1: string,
    password2: string,
    password1Validation: Validation,
    password2Validation: Validation,
    serverValidateFail: boolean,
    serverValidateMsg: ?string,
    resetting: boolean,
    resetted: boolean,
    submitButtonText: string
};

export class ResetPasswordContainer extends React.Component<Props, States> {
    state: States;
    constructor(props: Props) {
        super(props);
        const queryToken: string = ((queryParam("token"): any): string);
        this.state = {
            token: queryToken,
            password1: "",
            password1Validation: defaultValidation(),
            password2: "",
            password2Validation: defaultValidation(),
            resetting: false,
            resetted: false,
            submitButtonText: "Submit",
            serverValidateFail: false,
            serverValidateMsg: null
        };
    }

    onPassword1Changed = (e: Event, password1: string) => {
        const password1Validation = this.props.serviceManager.validationService.validatePassword(
            password1
        );
        this.setState({ password1, password1Validation });
    };

    onPassword2Changed = (e: Event, password2: string) => {
        const password2Validation = this.props.serviceManager.validationService.validatePassword2(
            this.state.password1,
            password2
        );
        this.setState({ password2, password2Validation });
    };

    resetPassword = async (e: Event) => {
        e.preventDefault();
        if (this.validate()) {
            const promiseReset = this.props.serviceManager.resetPasswordService.resetPassword(
                this.state.password1,
                this.state.token
            );
            this.setState({ resetting: true });
            try {
                await promiseReset;
                this.setState({ resetted: true });
            } catch (e) {
                this.setState({
                    serverValidateFail: true,
                    serverValidateMsg: e.errorMessage
                });
            } finally {
                this.setState({ resetting: false });
            }
        }
    };
    validate = () => {
        const password1Validation = this.props.serviceManager.validationService.validatePassword(
            this.state.password1
        );
        const password2Validation = this.props.serviceManager.validationService.validatePassword2(
            this.state.password1,
            this.state.password2
        );
        this.setState({
            password1Validation,
            password2Validation,
            serverValidateFail: false,
            serverValidateMsg: null
        });
        return (
            password1Validation.success === "success" &&
            password2Validation.success === "success"
        );
    };

    shouldDisableSubmit = () => {
        if (this.state.password1Validation.success === "fail") {
            return true;
        }
        if (this.state.password2Validation.success === "fail") {
            return true;
        }
        if (this.state.resetting === true) {
            return true;
        }
        return false;
    };

    render = () => {
        return (
            <div className="login-page__section-login">
                <h1 className="login-page__section-login-header">
                    Reset Password
                </h1>
                <hr />
                <div className="form-intro">
                    Please choose a new password to proceed.
                </div>
                <div className="form-wrapper login-page__section-login-form">
                    <ResetPassword
                        password1={this.state.password1}
                        password1Validation={this.state.password1Validation}
                        password2={this.state.password2}
                        password2Validation={this.state.password2Validation}
                        serverValidateFail={this.state.serverValidateFail}
                        serverValidateMsg={this.state.serverValidateMsg}
                        resetted={this.state.resetted}
                        status={this.state.resetting ? "loading" : ""}
                        disabledSubmit={this.shouldDisableSubmit()}
                        submitButtonText={this.state.submitButtonText}
                        onPassword1Changed={this.onPassword1Changed}
                        onPassword2Changed={this.onPassword2Changed}
                        onSubmit={this.resetPassword}
                    />
                </div>
            </div>
        );
    };
}

function defaultValidation() {
    return {
        success: "",
        required: false,
        complex: false,
        match: false
    };
}
